<template>
  <div class="form-page">
    <g-title tag="h1" size="m">{{ additionalUserInfo.Title }}</g-title>
    <g-markdown :content="additionalUserInfo.Text" />

    <template v-for="(question, index) in additionalUserInfo.Questions">
      <RadioGroup
        v-if="question.__typename === 'ComponentStandardComponentsRadioGroup'"
        :key="index"
        :label="question.Label"
        :wide="question.Wide"
        :entity="question.Entity"
        :choices="question.RadioChoices"
        @change="value => onAdditionalChange(value, question.Entity)"
      />
      <Slider
        v-else-if="question.__typename === 'ComponentStandardComponentsSlider'"
        :key="`s:${index}`"
        :label="question.Label"
        :description="question.Description"
        :display-min="question.MinLabel"
        :display-max="question.MaxLabel"
        :start-percentage="question.StartPercentage"
        @change="value => onAdditionalChange(value, question.Entity)"
      />
    </template>

    <!--  <RadioGroup
      v-for="(group, index) in additionalUserInfo.Questions"
      :key="index"
      :wide="group.Wide"
      :entity="group.Entity"
      :label="group.Label"
      :choices="group.RadioChoices"
      @change="onAdditionalChange"
    /> -->
    <!--  <RadioGroup
      v-if="age >= sexualOrientationAgeLimit"
      label="Identifierar du dig med HBTQIA+?"
      :choices="[
        { Label: 'Ja', Value: 'ja' },
        { Label: 'Nej', Value: 'nej' },
        { Label: 'Osäker', Value: 'osaker' },
        { Label: 'Vill inte svara', Value: 'vill_inte_svara' }
      ]"
      :wide="true"
      @change="onSexualOrientationChange"
    /> -->

    <g-button @click.prevent="startTest">FORTSÄTT</g-button>
  </div>
</template>

<script>
import RadioGroup from '@/components/RadioGroup';
import GET_ADDITIONAL_FORM from '@/graphql/AdditionalUserInfo.gql';
import UPDATE_STATISTIC from '@/graphql/story/UpdateStatistic.gql';
import Slider from '@/components/Slider';
//const sexualOrientationAgeLimit = 14;

export default {
  components: {
    RadioGroup,
    Slider
  },
  apollo: {
    additionalUserInfo: {
      query: GET_ADDITIONAL_FORM
    }
  },
  data() {
    return {
      // age: -1,
      // sexualOrientationAgeLimit,
      sexualOrientation: '',
      additionalUserInfo: {
        Title: '',
        Text: ''
      },
      formData: {}
    };
  },
  created() {
    const userObj = JSON.parse(window.sessionStorage.getItem('userObject'));
    //this.age = userObj.formData.age;
  },
  methods: {
    startTest() {
      const userObj = JSON.parse(window.sessionStorage.getItem('userObject'));
      let existingFormData = userObj.formData;

      this.formData.sexualOrientation = this.sexualOrientation;

      userObj.formData = { ...existingFormData, ...this.formData };
      userObj['enteredAdditional'] = true;

      if (userObj.hasOwnProperty('statistic_id')) {
        this.$apollo.mutate({
          mutation: UPDATE_STATISTIC,
          variables: {
            input: {
              where: {
                id: parseInt(userObj.statistic_id)
              },
              data: {
                Data: userObj
              }
            }
          }
        });
      }

      window.sessionStorage.setItem('userObject', JSON.stringify(userObj));

      this.$router.push('/story/' + this.$route.params.id);
    },
    /* onSexualOrientationChange(value) {
      // Double Checking the age limit
      if (this.age < sexualOrientationAgeLimit) {
        return;
      }

      this.sexualOrientation = value;
    }, */
    onAdditionalChange(value, entity) {
      this.formData[entity] = value;
    }
  }
};
</script>

<style lang="scss" scoped></style>
